import React, {useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    makeStyles
} from '@ellucian/react-design-system/core';
import { FormattedMessage, useIntl } from 'react-intl';
import Icon from '@ellucian/ds-icons/lib/es6/Icon';
import { spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import { useSnackbar } from '../SnackbarContext/SnackbarContext';

const useStyles = makeStyles(() => ({
    icon: {
        marginRight: spacing40
    },
    button: {
        marginRight: spacing40
    }
}));

const SupplementalItemsUploadDialog = props => {
    const { onClose, itemName, maxUploads, fullScreen } = props;
    const {formatMessage} = useIntl();
    const snackbar = useSnackbar();
    const classes = useStyles();
    const [uploads, setUploads] = useState([]);
    const inputFile = useRef(null);

    const handleUploadClick = () => {
        if ((!maxUploads) || (maxUploads && uploads.length < maxUploads)) {
            inputFile.current.click();
        }
        else {
            snackbar.warning(formatMessage({ id: 'supplementalItemsDialogSnackbarWarning' }));
        }  
    };

    const onChangeFile = (event) => {
        event.stopPropagation();
        event.preventDefault();
        var file = event.target.files[0];
        setUploads([...uploads, file]);
    };

    return (
        <div>
            <input type='file' id='file' ref={inputFile} style={{display: 'none'}} onChange={onChangeFile}/>
            <Dialog
                open={true}
                onClose={onClose}
                maxWidth="lg"
                fullScreen={fullScreen ? true : false }
            >
                <DialogTitle>
                    <FormattedMessage id="supplementalItemsDialogTitle"/>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <strong><FormattedMessage id={itemName}/></strong>
                    </DialogContentText>
                    <DialogContentText>
                        { maxUploads &&
                            <FormattedMessage id="supplementalItemsDialogMaximumUploads"
                                values={{
                                    number: maxUploads
                                }}
                            />
                        }
                    </DialogContentText>
                    <DialogContentText>
                        <Button 
                            color="secondary" 
                            className={classes.button}
                            onClick={handleUploadClick}
                        >
                            <Icon name="upload" className={classes.icon} />
                            <FormattedMessage id="supplementalItemsDialogChooseFile"/>
                        </Button>
                        <FormattedMessage id="supplementalItemsDialogMaximumWarning"
                            values={{
                                maxFileSize: 5 //this will need to be replaced when the admin side of this story is complete with the setting for max file size, hard coding is temporary
                            }}
                        />
                    </DialogContentText>
                    <Divider/>
                    { uploads.length === 0 && 
                            <DialogContentText>
                                <FormattedMessage id="supplementalItemsDialogNoFile"/>
                            </DialogContentText>
                    }
                    { uploads.length > 0 &&
                        uploads.map((item) => (
                            <DialogContentText key={item.name}>
                                {item.name}
                            </DialogContentText>
                        ))
                    }
                    <Divider/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary">
                        <FormattedMessage id="supplementalItemsDialogCancel"/>
                    </Button>
                    <Button onClick={onClose} color="primary">
                        <FormattedMessage id="supplementalItemsDialogSave"/>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

SupplementalItemsUploadDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    itemName: PropTypes.string.isRequired,
    maxUploads: PropTypes.number,
    fullScreen: PropTypes.bool
};

export default SupplementalItemsUploadDialog;